import React, { useEffect, useRef, useState } from 'react';
import { Formik, Form as FormikForm, Field, ErrorMessage } from 'formik';
import 'bootstrap/dist/css/bootstrap.min.css';
import * as Yup from 'yup';
import { Row, Col, Button, Card } from 'react-bootstrap';
import PageTitle from '../../../layouts/PageTitle';
import { connect, useDispatch } from 'react-redux';
import { employeeSearchList } from '../../../../store/selectors/BoxSelectors';
import { getProfile } from '../../../../store/selectors/AuthSelectors';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import { useLoader } from '../../../../context/LoaderCotext';
import { getMTEByEmail } from '../../../../services/MTEService';
import Swal from 'sweetalert2';

import { retrieveData, storeData } from '../../../../services/indexedDBUtils';
import {
  getBoxAuthToken,
  getBoxAuthUrl,
  getUsersSearch,
  uploadFileBatch,
} from '../../../../services/BoxService';
import { checkCOISubmission } from '../../../../services/FormService';
import { useAuth } from '../../../../context/authContext';
import Cookies from 'js-cookie';
import { createFormAction } from '../../../../store/actions/FormsActions';
import { Link, useLocation, useNavigate } from 'react-router-dom';

const validationSchema = Yup.object({
  employeeName: Yup.string().required('Employee name is required'),
  employeeNumber: Yup.string().required('Employee number is required'),
  manager: Yup.string().required('Manager is required'),
  ethicalAndStatement: Yup.boolean().oneOf([true], 'Ethical And Statement is required'),
  outsideInterest: Yup.boolean().oneOf([true], 'Outside Interest is required'),
  question1: Yup.boolean().required('Question 1 is required'),
  question2: Yup.boolean().required('Question 2 is required'),
  question3: Yup.boolean().required('Question 3 is required'),
  question4: Yup.boolean().required('Question 4 is required'),
  question5: Yup.boolean().required('Question 5 is required'),
  disclosureGuidelines: Yup.boolean().oneOf([true], 'Disclosure Guidelines is required'),
  statement1: Yup.string().test(
    'statement1', // Test name
    'This field is required because of the questions 1 is YES', // Validation error message
    function (value) {
      const { question1 } = this.parent; // Access sibling fields
      const anyTrue = question1; // Check if any question is true
      if (anyTrue) {
        return value !== undefined && value !== ''; // Return true if value exists
      }
      return true; // Pass if none are true
    }
  ),
  statement2: Yup.string().test(
    'statement2', // Test name
    'This field is required because of the questions 2 is YES', // Validation error message
    function (value) {
      const { question2 } = this.parent; // Access sibling fields
      const anyTrue = question2; // Check if any question is true
      if (anyTrue) {
        return value !== undefined && value !== ''; // Return true if value exists
      }
      return true; // Pass if none are true
    }
  ),
  statement3: Yup.string().test(
    'statement3', // Test name
    'This field is required because of the questions 3 is YES', // Validation error message
    function (value) {
      const { question3 } = this.parent; // Access sibling fields
      const anyTrue = question3; // Check if any question is true
      if (anyTrue) {
        return value !== undefined && value !== ''; // Return true if value exists
      }
      return true; // Pass if none are true
    }
  ),
  statement4: Yup.string().test(
    'statement4', // Test name
    'This field is required because of the questions 4 is YES', // Validation error message
    function (value) {
      const { question4 } = this.parent; // Access sibling fields
      const anyTrue = question4; // Check if any question is true
      if (anyTrue) {
        return value !== undefined && value !== ''; // Return true if value exists
      }
      return true; // Pass if none are true
    }
  ),
  statement5: Yup.string().test(
    'statement5', // Test name
    'This field is required because of the questions 5 is YES', // Validation error message
    function (value) {
      const { question5 } = this.parent; // Access sibling fields
      const anyTrue = question5; // Check if any question is true
      if (anyTrue) {
        return value !== undefined && value !== ''; // Return true if value exists
      }
      return true; // Pass if none are true
    }
  ),
});

const ScrollToEnableCheckbox = ({ name, label, content, errorMsg }) => {
  const [isCheckboxEnabled, setIsCheckboxEnabled] = useState(false);
  const [showError, setShowError] = useState(false);
  const contentRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const element = contentRef.current;
      if (element) {
        const isScrolledToBottom =
          element.scrollTop + element.clientHeight >= element.scrollHeight - 50;
        if (isScrolledToBottom) {
          setIsCheckboxEnabled(true);
          setShowError(false); // Clear the error when scrolled to bottom
        }
      }
    };

    const element = contentRef.current;
    if (element) {
      element.addEventListener('scroll', handleScroll);
    }

    return () => {
      if (element) {
        element.removeEventListener('scroll', handleScroll);
      }
    };
  }, []);

  const handleLabelClick = (event) => {
    if (!isCheckboxEnabled) {
      event.preventDefault(); // Prevent default click action on the checkbox
      setShowError(true); // Show error message
    }
  };

  return (
    <div className="form-group">
      <div
        ref={contentRef}
        style={{
          maxHeight: '150px',
          overflowY: 'auto',
          border: '1px solid #ccc',
          borderRadius: '5px',
          padding: '10px',
        }}
        className="mb-3"
      >
        <p style={{ padding: '10px' }} dangerouslySetInnerHTML={{ __html: content }}></p>
      </div>
      <label onClick={handleLabelClick}>
        <Field type="checkbox" name={name} disabled={!isCheckboxEnabled} /> {label}
      </label>
      {showError && <div className="text-danger">{errorMsg}</div>}
      <ErrorMessage name={name} component="div" className="text-danger" />
    </div>
  );
};

const COIForm = ({ profile }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { hasPermission } = useAuth();
  const { showLoader, hideLoader } = useLoader();
  const [submitterName, setSubmitterName] = useState('');
  const [folderAPISuccess, setFolderAPISuccess] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [cookieValue, setCookieValue] = useState(Cookies.get('boxToken'));
  const [initialValues, setInitialValues] = useState({
    employeeName: '',
    employeeNumber: '',
    manager: '',
    ethicalAndStatement: false,
    outsideInterest: false,
    question1: false,
    question2: false,
    question3: false,
    question4: false,
    question5: false,
    disclosureGuidelines: false,
    statement1: '',
    statement2: '',
    statement3: '',
    statement4: '',
    statement5: '',
    boxFolderId: '364139876692',
    boxFolderName: 'COI-Forms',
    timestamp: moment().unix(),
  });

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const authCode = searchParams.get('code');
    const apiCall = async () => {
      if (typeof authCode != 'undefined' && authCode != '' && authCode != null) {
        await getBoxAuthToken(authCode)
          .then(async (response) => {
            if (typeof response.data.key != 'undefined') {
              const expiryDate = new Date();
              expiryDate.setTime(expiryDate.getTime() + response.data.life * 1000);
              Cookies.set('boxToken', response.data.key, {
                expires: expiryDate,
                path: '/',
                secure: true,
              });
              setCookieValue(Cookies.get('boxToken'));
              setFolderAPISuccess(true);
            }
          })
          .catch(async (error) => {});
      } else {
        setFolderAPISuccess(true);
      }
    };
    if (typeof cookieValue == 'undefined' && hasPermission('box-folders', ['show']) == true) {
      apiCall();
    } else {
      setFolderAPISuccess(true);
    }
  }, [cookieValue]);

  useEffect(() => {
    getUsersSearch(profile?.email)
      .then(async (response) => {
        const getManager = await getMTEByEmail(response.data[0].email);
        setInitialValues({
          ...initialValues,
          employeeName: `${response.data[0].firstName} ${response.data[0].lastName}`,
          employeeNumber: response.data[0].employeeNumber,
          manager: getManager.manager || 'Not assigned',
          email: response.data[0].email,
        });
      })
      .catch((error) => {
        console.error('Error fetching employee data', error);
      });
  }, []);

  const [hasDashboardMenu, setHasDashboardMenu] = useState(true);
  useEffect(() => {
    if (typeof profile != 'undefined') {
      setSubmitterName(profile.firstName + ' ' + profile.lastName);

      const checkSubmission = async () => {
        try {
          const year = moment().format('YYYY');
          const result = await checkCOISubmission(profile.email, year);
          if (result && (result.exists || (Array.isArray(result) && result.length > 0))) {
            setIsSubmitted(true);
            Swal.fire({
              icon: 'info',
              title: 'Already Submitted',
              text: `You have submitted COI form for ${year}`,
              allowOutsideClick: false,
              allowEscapeKey: false,
              showConfirmButton: false,
              footer: '<a href="/dashboard">Go to Dashboard</a>',
            });
          }
        } catch (error) {
          console.error('Error checking COI submission:', error);
        }
      };

      if (profile.email) {
        checkSubmission();
      }
    }
    if (profile && profile.allowedModules) {
      const hasDashboard = profile.allowedModules.some(
        (module) => module.value.trim() === 'dashboard' && module.operations.includes('menu')
      );
      if (hasDashboard == false) {
        setHasDashboardMenu(false);
      }
    }
  }, [profile]);

  const handleUploadBatch = async (data) => {
    const payload = {
      submitterName: profile ? profile.firstName + ' ' + profile.lastName : '',
      submitterEmail: profile.email,
      status: 'in progress',
      formType: 'coi-form',
      contractor: 'ssai',
      dynamicFields: [
        {
          submitter: profile ? profile.firstName + ' ' + profile.lastName : '',
          ...data,
        },
      ],
    };
    if (
      localStorage.getItem('formDataJSON') == null ||
      typeof localStorage.getItem('formDataJSON') == 'undefined'
    ) {
      localStorage.setItem('formDataJSON', await storeData(payload));
    }

    const formData = await retrieveData(parseInt(localStorage.getItem('formDataJSON')));

    if (formData) {
      const payload = {
        data: formData.dynamicFields,
        key: cookieValue || '',
        isBoxExplorer: hasPermission('box-folders', ['show']) || false,
      };
      try {
        showLoader();
        const response = await uploadFileBatch(payload);
        if (Array.isArray(formData.dynamicFields)) {
          formData.dynamicFields.forEach((data, index) => {
            if (index === formData.dynamicFields.length - 1) {
              dispatch(createFormAction({ ...formData, dynamicFields: data }, navigate));
            } else {
              dispatch(createFormAction({ ...formData, dynamicFields: data }, undefined));
            }
          });
        } else {
          hasDashboardMenu == true ? navigate('/dashboard') : navigate('/forms');
        }

        Swal.fire({
          icon: 'success',
          title: 'Request submitted',
          text: 'Your request is submitted please wait for approver',
          width: 400,
          confirmButtonColor: '#3a7afe',
        }).then(() => {
          hasDashboardMenu == true ? navigate('/dashboard') : navigate('/forms');
        });
      } catch (error) {
        if (
          typeof error.response != 'undefined' &&
          typeof error.response.status != 'undefined' &&
          error.response.status == '501'
        ) {
          Swal.fire({
            icon: 'error',
            title: 'Employee Data Error',
            text: 'Employee data not exist on box, Please contact your admin',
            width: 400,
            confirmButtonColor: '#3a7afe',
          });
          hasDashboardMenu == true ? navigate('/dashboard') : navigate('/forms');
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Request not submitted',
            text: 'Please contact your admin',
            width: 400,
            confirmButtonColor: '#3a7afe',
          });
          console.error(
            'Error uploading file:',
            error.response ? error.response.data : error.message
          );
        }
      } finally {
        hideLoader();
      }
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Data not existed',
        text: 'Please contact your admin',
        width: 400,
        confirmButtonColor: '#3a7afe',
      });
      hasDashboardMenu == true ? navigate('/dashboard') : navigate('/forms');
    }
  };

  const handleSubmit = (data) => {
    if (typeof data != 'undefined') {
      const payloadForms = {
        ...data,
        submitter: profile ? profile.firstName + ' ' + profile.lastName : '',
      };
      handleUploadBatch(payloadForms);
    }
  };

  return (
    <>
      <PageTitle pageTitle="Conflict of Interest- 55HRM" />
      <Card className="form-container" style={{ padding: '1rem 2rem 2rem 2rem' }}>
        <div
          className="d-flex justify-content-end"
          style={{ fontSize: '14px', fontWeight: '600', marginBottom: '10px' }}
        >
          <Link
            className="mb-2 text-primary"
            target="_blank"
            to="https://ssaihq.app.box.com/file/1756646963389"
          >
            Instruction to Submit the COI form
          </Link>
          <Link
            className="mb-2 text-primary"
            target="_blank"
            style={{ marginLeft: '40px' }}
            to="https://ssaihq.app.box.com/file/1756655003572"
          >
            Policy 8-006 for Conflicts of Interest
          </Link>
        </div>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          enableReinitialize={true}
          onSubmit={handleSubmit}
        >
          {({ values, setFieldValue, isSubmitting }) => (
            <FormikForm>
              <Row className="mb-3" style={{ flexWrap: 'nowrap' }}>
                <Col>
                  <div className="form-group">
                    <label htmlFor="employeeName">Employee Name</label>
                    <Field
                      type="text"
                      name="employeeName"
                      className="form-control"
                      placeholder="Employee Name"
                      value={values.employeeName}
                      readOnly
                    />
                    <ErrorMessage name="employeeName" component="div" className="text-danger" />
                  </div>
                </Col>
                <Col>
                  <div className="form-group">
                    <label htmlFor="employeeNumber">Employee Number</label>
                    <Field
                      type="text"
                      name="employeeNumber"
                      className="form-control"
                      placeholder="Employee Number"
                      value={values.employeeNumber}
                      readOnly
                    />
                    <ErrorMessage name="employeeNumber" component="div" className="text-danger" />
                  </div>
                </Col>
                <Col>
                  <div className="form-group">
                    <label htmlFor="Manager">Manager</label>
                    <Field
                      type="text"
                      name="manager"
                      className="form-control"
                      placeholder="Manager"
                      value={values.manager}
                      readOnly
                    />
                    <ErrorMessage name="manager" component="div" className="text-danger" />
                  </div>
                </Col>
              </Row>
              <Row className="mb-3" style={{ flexWrap: 'nowrap' }}>
                <Col>
                  <ScrollToEnableCheckbox
                    name="ethicalAndStatement"
                    label="Ethical And Legal Statement"
                    content="SSAI’s policy <a href='https://ssaihq.app.box.com/file/1756655003572' target='_blank'><strong>
                    (Policy 8‐006)</strong></a> is that it expects all
                        employees to adhere to the highest standards of business
                        ethics. No employee should take actions on behalf of the
                        company that they know, or reasonably should know,
                        violate any applicable law or regulation or ethical
                        business tenet. SSAI bases its policy on Financial and
                        Personal Conflict of Interest on a strong commitment to
                        promoting business interaction integrity, objectivity,
                        and compliance with Federal Acquisition Regulations
                        (FAR) requirements. SSAI’s Standards of Business Ethics
                        Conduct Handbook (available on the EIS Web site under
                        the “Ethics” button) provides employee guidance on
                        adhering to our core ethical values and business
                        practices. In our complex environment of complying with
                        procurement regulations, we must be vigilant in our
                        commitment to promoting business integrity, objectivity,
                        and openness. We must be aware that personal or
                        financial relationships between parties (spouse, close
                        friend, relative, etc.) where one works for a vendor or
                        customer doing business with SSAI can create the
                        “appearance of a conflict of interest” that can take on
                        legal complications and standing. This is especially
                        true if these relationships are not reported and
                        documented, with appropriate isolation/avoidance steps
                        taken as necessary. In order to protect SSAI, our
                        employees, and our business customers, our policy
                        requires all employees to file an annual disclosure form
                        for identification of potential or known sources of
                        conflict and to develop an avoidance approach. The
                        objective is to ensure that all employee actions
                        conducted on behalf of SSAI and in the execution of our
                        contracts are done without bias or influence by
                        financial interests, personal relationships, or other
                        biased business obligations. SSAI management will use
                        this information to avoid assigning an employee to a
                        role that might create a conflict of interest or even
                        the appearance of a conflict of interest"
                    errorMsg="Please read the entire content of ethical and legal
                        statement before proceeding."
                  />
                </Col>
              </Row>
              <Row className="mb-3" style={{ flexWrap: 'nowrap' }}>
                <Col>
                  <ScrollToEnableCheckbox
                    name="outsideInterest"
                    label="Outside Interest"
                    content="An employee is considered to have an interest in an outside business if the employee or any member of his/her immediate family (spouse, brother, sister, parent, grandparent, child, stepchild, grandchild, father‐in‐law, mother‐in‐law, sister‐in‐law, brother‐in‐law, son‐in‐law, daughter‐in‐law, and any other dependent member of the employee’s household) holds any ownership in the business or its property; furnishes goods or services to the business; or is a creditor, employee, agent, board member, partner, officer, director, or consultant of the business. Outside businesses include any person, firm, corporation, or Federal, State, or local government agency that sells or provides a service to, purchases from, or competes with SSAI. The most common situation that arises in our business environment is where an immediate family member is a Federal employee with an agency with which SSAI may do business, thus creating an outside interest for them. Excluded from financial consideration are investments in the securities of banks, public utilities, and transportation companies subject to regulations by government authority, or a mutual fund or investment company registered under the Investment Company Act. Also excluded are securities listed on a national securities exchange or customarily bought and sold a least once a week in the over‐the‐counter market or in which the employee and/or his or her family member(s) have less than $10,000 invested, at cost or market value, or hold less than five percent of such outstanding securities (whichever is smaller). In keeping with this policy implementation, all employees must complete the Disclosure of Significant Financial Interests, Relationships, and Obligations form (55HRD) on or before January 15th of each year. If an employee’s financial or relationship disclosure status changes during the course of the year, an updated form is required to be filed within 10 business days of the event causing the status change. The completed Disclosure of Significant Financial Interests, Relationships, and Obligations should be placed in a sealed envelope, marked “Confidential,” and forwarded to the SSAI Human Resources Manager. Compliance with this policy is a requirement for employment with SSAI. Questions regarding the implementation of this policy or the submission of required forms should be directed to the Human Resources Department at hr_lanham@ssaihq.com"
                    errorMsg="Please read the entire content of outside interest
                        before proceeding."
                  />
                </Col>
              </Row>
              <Row className="mb-3" style={{ flexWrap: 'nowrap' }}>
                <Col md={10}>
                  <div className="form-group">
                    <label htmlFor="question1">
                      1) Do you have any immediate family relationships (e.g., civil servant
                      positions with Federal agencies with which SSAI may do business) that might
                      give the appearance of creating a possible conflict of interest?
                    </label>
                    <ErrorMessage name="question1" component="div" className="text-danger" />
                  </div>
                </Col>
                <Col md={2}>
                  <div role="group">
                    <label htmlFor="yesquestion1" style={{ marginRight: '10px' }}>
                      <Field
                        type="radio"
                        name="question1"
                        value="true"
                        id="yesquestion1"
                        style={{ marginRight: '5px' }}
                      />
                      Yes
                    </label>

                    <label htmlFor="noquestion1">
                      <Field
                        type="radio"
                        name="question1"
                        value="false"
                        id="noquestion1"
                        style={{ marginRight: '5px' }}
                      />
                      No
                    </label>
                  </div>
                </Col>
              </Row>
              {JSON.parse(values.question1) && (
                <Row className="mb-3" style={{ flexWrap: 'nowrap' }}>
                  <Col>
                    <div className="form-group">
                      <label htmlFor="statement1">Statement for question 1</label>
                      <Field
                        as="textarea"
                        name="statement1"
                        className="form-control"
                        placeholder="Statement"
                        value={values.statement1}
                      />
                      <ErrorMessage name="statement" component="div" className="text-danger" />
                    </div>
                  </Col>
                </Row>
              )}
              <Row className="mb-3" style={{ flexWrap: 'nowrap' }}>
                <Col md={10}>
                  <div className="form-group">
                    <label htmlFor="question2">
                      2) Is it reasonable to anticipate that any other relationship(s) could be
                      directly and significantly affected by the design, conduct, or execution of
                      your regular work activities?
                    </label>
                    <ErrorMessage name="question2" component="div" className="text-danger" />
                  </div>
                </Col>
                <Col md={2}>
                  <div role="group">
                    <label htmlFor="yesquestion2" style={{ marginRight: '10px' }}>
                      <Field
                        type="radio"
                        name="question2"
                        value="true"
                        id="yesquestion2"
                        style={{ marginRight: '5px' }}
                      />
                      Yes
                    </label>

                    <label htmlFor="noquestion2">
                      <Field
                        type="radio"
                        name="question2"
                        value="false"
                        id="noquestion2"
                        style={{ marginRight: '5px' }}
                      />
                      No
                    </label>
                  </div>
                </Col>
              </Row>
              {JSON.parse(values.question2) && (
                <Row className="mb-3" style={{ flexWrap: 'nowrap' }}>
                  <Col>
                    <div className="form-group">
                      <label htmlFor="statement2">Statement for question 2</label>
                      <Field
                        as="textarea"
                        name="statement2"
                        className="form-control"
                        placeholder="Statement"
                        value={values.statement2}
                      />
                      <ErrorMessage name="statement" component="div" className="text-danger" />
                    </div>
                  </Col>
                </Row>
              )}
              <Row className="mb-3" style={{ flexWrap: 'nowrap' }}>
                <Col md={10}>
                  <div className="form-group">
                    <label htmlFor="question3">
                      3) Do you or any member of your immediate family hold any interest in an
                      outside business in such terms as identified above that supplies property,
                      furnishes goods or services to SSAI, or engages in any business that is
                      competitive with SSAI?
                    </label>
                    <ErrorMessage name="question3" component="div" className="text-danger" />
                  </div>
                </Col>
                <Col md={2}>
                  <div role="group">
                    <label htmlFor="yesquestion3" style={{ marginRight: '10px' }}>
                      <Field
                        type="radio"
                        name="question3"
                        value="true"
                        id="yesquestion3"
                        style={{ marginRight: '5px' }}
                      />
                      Yes
                    </label>

                    <label htmlFor="noquestion3">
                      <Field
                        type="radio"
                        name="question3"
                        value="false"
                        id="noquestion3"
                        style={{ marginRight: '5px' }}
                      />
                      No
                    </label>
                  </div>
                </Col>
              </Row>
              {JSON.parse(values.question3) && (
                <Row className="mb-3" style={{ flexWrap: 'nowrap' }}>
                  <Col>
                    <div className="form-group">
                      <label htmlFor="statement3">Statement for question 3</label>
                      <Field
                        as="textarea"
                        name="statement3"
                        className="form-control"
                        placeholder="Statement"
                        value={values.statement3}
                      />
                      <ErrorMessage name="statement" component="div" className="text-danger" />
                    </div>
                  </Col>
                </Row>
              )}
              <Row className="mb-3" style={{ flexWrap: 'nowrap' }}>
                <Col md={10}>
                  <div className="form-group">
                    <label htmlFor="question4">
                      4) Have you or any member of your immediate family received, in the last
                      twelve (12) months, or expect to receive in the next twelve (12) months from
                      an outside business as defined above, payments for salary, director’s fees,
                      consulting honoraria, royalties, or any other payments that, when aggregated
                      with payments from this organization, will exceed $10,000?
                    </label>
                    <ErrorMessage name="question4" component="div" className="text-danger" />
                  </div>
                </Col>
                <Col md={2}>
                  <div role="group">
                    <label htmlFor="yesquestion4" style={{ marginRight: '10px' }}>
                      <Field
                        type="radio"
                        name="question4"
                        value="true"
                        id="yesquestion4"
                        style={{ marginRight: '5px' }}
                      />
                      Yes
                    </label>

                    <label htmlFor="noquestion4">
                      <Field
                        type="radio"
                        name="question4"
                        value="false"
                        id="noquestion4"
                        style={{ marginRight: '5px' }}
                      />
                      No
                    </label>
                  </div>
                </Col>
              </Row>
              {JSON.parse(values.question4) && (
                <Row className="mb-3" style={{ flexWrap: 'nowrap' }}>
                  <Col>
                    <div className="form-group">
                      <label htmlFor="statement4">Statement for question 4</label>
                      <Field
                        as="textarea"
                        name="statement4"
                        className="form-control"
                        placeholder="Statement"
                        value={values.statement4}
                      />
                      <ErrorMessage name="statement" component="div" className="text-danger" />
                    </div>
                  </Col>
                </Row>
              )}
              <Row className="mb-3" style={{ flexWrap: 'nowrap' }}>
                <Col md={10}>
                  <div className="form-group">
                    <label htmlFor="question5">
                      5) Did you or any member of your immediate family acquire “Significant
                      Financial Interests” during the last twelve (12) months or anticipate
                      acquiring such interest in the next twelve (12) months that directly affect or
                      may reasonably appear to affect your regular work decisions?
                    </label>
                    <ErrorMessage name="question5" component="div" className="text-danger" />
                  </div>
                  <p>
                    <strong>
                      ”Significant Financial Interest” includes stock, stock options, and/or any
                      other ownership interest in a single entity valued at more than $10,000 or 5%
                      ownership. Please note: Mutual fund holdings do not qualify.
                    </strong>
                  </p>
                </Col>
                <Col md={2}>
                  <div role="group">
                    <label htmlFor="yesquestion5" style={{ marginRight: '10px' }}>
                      <Field
                        type="radio"
                        name="question5"
                        value="true"
                        id="yesquestion5"
                        style={{ marginRight: '5px' }}
                      />
                      Yes
                    </label>

                    <label htmlFor="noquestion5">
                      <Field
                        type="radio"
                        name="question5"
                        value="false"
                        id="noquestion5"
                        style={{ marginRight: '5px' }}
                      />
                      No
                    </label>
                  </div>
                </Col>
              </Row>
              {JSON.parse(values.question5) && (
                <Row className="mb-3" style={{ flexWrap: 'nowrap' }}>
                  <Col>
                    <div className="form-group">
                      <label htmlFor="statement5">Statement for question 5</label>
                      <Field
                        as="textarea"
                        name="statement5"
                        className="form-control"
                        placeholder="Statement"
                        value={values.statement5}
                      />
                      <ErrorMessage name="statement" component="div" className="text-danger" />
                    </div>
                  </Col>
                </Row>
              )}
              <Row className="mb-3" style={{ padding: '13px' }}>
                <Col
                  style={{
                    border: '1px',
                    borderStyle: 'solid',
                    padding: '20px',
                    borderRadius: '5px',
                    borderColor: 'red',
                  }}
                >
                  <p>
                    If you answered “No” to ALL of the questions above, your Disclosure is complete.
                  </p>
                  <p>
                    <strong>
                      If you answered “Yes” to ANY question above, please type a statement in the
                      text area below detailing the following information for each person or
                      organization that you or your immediate family member have the relationship(s)
                      indicated above:
                    </strong>
                  </p>

                  <p>
                    A) The name of the individual or organization agency for which the significant
                    financial interest, relationship, and/or obligation exists.
                  </p>
                  <p>
                    B) A description of the relationships ( i.e,. role or title and agency if civil
                    servant).
                  </p>
                  <p>
                    C) If applicable, list any other relationships, commitments, or activities that
                    you or any member of your immediate family have that might present or reasonably
                    appear to present a conflict of interest in your employment with SSAI.
                  </p>
                  <p>
                    <strong>Employee Certification:</strong>
                  </p>
                  <p>
                    • I have read and understand SSAI’s Policy (8‐006) on Financial and Personal
                    Conflict of Interest.
                  </p>
                  <p>
                    • I agree to file a new or updated Disclosure of Significant Financial
                    Interests, Relationships, and Obligations form if the answer to any of the
                    questions changes.
                  </p>
                  <p>
                    • I certify that the answers to the declaration are accurate and truthful to the
                    best of my knowledge{' '}
                  </p>
                </Col>
              </Row>
              <Row className="mb-3" style={{ flexWrap: 'nowrap' }}>
                <Col>
                  <div className="form-group">
                    <label>
                      <Field type="checkbox" name="disclosureGuidelines" /> Disclosure Guidelines
                    </label>
                    <ErrorMessage
                      name="disclosureGuidelines"
                      component="div"
                      className="text-danger"
                    />
                  </div>
                </Col>
              </Row>
              <div className="d-flex justify-content-end mt-4">
                <Button variant="primary" type="submit" disabled={isSubmitted}>
                  Submit
                </Button>
              </div>
            </FormikForm>
          )}
        </Formik>
      </Card>
    </>
  );
};

const mapStateToProps = (state) => ({
  profile: getProfile(state),
  employeeList: employeeSearchList(state),
});

export default connect(mapStateToProps)(COIForm);
